<template>
    <div class="plano_modal" v-if="visible">
        <b-card>
            <label> <h3>Edit Hook</h3> </label>
            <b-container fluid>
                <b-row>
                    <b-col sm="4"> <label>Fixed:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="fixed"></b-form-checkbox> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>X:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="x"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Y:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="y"></NumberInput> </b-col>
                </b-row>
            </b-container>
            <b-button-toolbar>
                <b-button style="margin:5px;" variant="primary" @click="validate();">Ok</b-button>
                <b-button style="margin:5px;" @click="cancel();">Cancel</b-button>
            </b-button-toolbar>
        </b-card>
    </div>
</template>

<script>
import NumberInput from "../components/number-input";

let editBoardHookWidget;
window.editBoardHook = function editBoardHook(data, onValidate, onCancel) {
    editBoardHookWidget.fixed = data.fixed;
    editBoardHookWidget.x = data.x;
    editBoardHookWidget.y = data.y;
    editBoardHookWidget.visible = true;
    editBoardHookWidget.onValidate = onValidate;
    editBoardHookWidget.onCancel = onCancel;
};

export default {
    components: { NumberInput },
    data() {
        return {
            x: 0,
            y: 0,
            fixed: false,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    created() {
        editBoardHookWidget = this;
    },
    methods: {
        validate() {
            this.onValidate({
                x: parseFloat(this.x),
                y: parseFloat(this.y),
                fixed: this.fixed
            });
            this.visible = false;
        },
        cancel() {
            this.onCancel();
            this.visible = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// edit_board_hook.vue?959b161e